import { render, staticRenderFns } from "./PackagesView.vue?vue&type=template&id=373c1dc2&scoped=true&"
import script from "./PackagesView.vue?vue&type=script&lang=js&"
export * from "./PackagesView.vue?vue&type=script&lang=js&"
import style0 from "./PackagesView.vue?vue&type=style&index=0&id=373c1dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c1dc2",
  null
  
)

export default component.exports